import {Layout} from '@/ui/kit/Layout/Layout';
import {Preloader} from '@/ui/kit/Preloader/Preloader';

import s from './LoaderPageWeb.module.css';

export function LoaderPageWeb(): JSX.Element {
  return (
    <Layout classNameMain={s.root}>
      <Preloader />
    </Layout>
  );
}
